module.exports = __webpack_public_path__ + "static/media/logos-print-selfie-harakiri.f6518790.jpg";